// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__4LF2H","bodyText":"styles_bodyText__C_bKK","captionText":"styles_captionText__gUNei","btnClienteClaro":"styles_btnClienteClaro__SARFx"};